import React from 'react';
import { Page } from '../PageTitle/Page';

export const SignInPage = () => (
    <Page title="Sign In">{null}</Page>
);